<template>
  <div class="board-faq">
    <TopBarText
      :partners-key="partnersKey"
      :gnb-data="gnbData"
      custom-text-link="inquiry-text-link"
    />
    <div class="board-faq-header mx-auto">
      <p class="title">
        {{ $t('faq.title') }}
      </p>
      <div class="subtitle">
        {{ $t('faq.subtitle') }}
      </div>
    </div>
    <ADivider />
    <div class="board-faq-body pb-60">
      <el-collapse
        v-model="activeName"
        class="faq-list-container mt-20"
        accordion
        @change="handleFocus"
      >
        <div
          v-for="item in faqData"
          :key="item.boardId"
          ref="faqItem"
          class="faq-list flex flex-column flex-align-start"
        >
          <el-collapse-item :name="item.boardId">
            <template #title>
              <div
                :id="item.boardId"
                ref="titles"
                class="board-faq-title"
              >
                {{ item.title }}
              </div>
            </template>
            <div
              v-dompurify-html="item.answer"
              class="board-faq-desc"
            />
          </el-collapse-item>
        </div>
      </el-collapse>
    </div>
    <el-backtop
      target=".board-faq"
      :right="40"
      :bottom="175"
      :visibility-height="10"
    >
      <UpperArrow />
    </el-backtop>
  </div>
</template>

<script setup lang="ts">

const faqData = ref<any[]>([])
const activeName = ref<string>()
const titles = ref<HTMLElement[]>([])
const selected = ref<boolean>(false)

withDefaults(
  defineProps<{
    gnbData: any,
    partnersKey?: string
  }>(),
  {
    partnersKey: ''
  }
)

const handleFocus = (activeName:any) => {
  if (!selected.value) {
    selected.value = !!activeName
    return
  }
  const activeTitle = titles.value?.find(el => el.id === activeName)
  selected.value = !!activeName
  if (activeTitle) {
    setTimeout(() => {
      activeTitle.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }, 400)
  }
}

const loadFaqData = () => {
  useApi().getBoardByFaq().then((res:any) => {
    res.data.forEach((item:any) => {
      const data = { ...item }
      data.answer = item.content.replaceAll('\r\n', '<br />')
      faqData.value.push(data)
    })
  })
}

loadFaqData()

</script>
